import React from "react";
import styled from "styled-components";

export const FilterGroupContainer = styled.div`
  box-sizing: border-box;
  min-width: 10.5rem;
  padding: 0 1rem;
`;

const FilterGroupHeader = styled.h5`
  text-transform: uppercase;
  margin: 0 0 1rem 0;
`;

interface FilterGroupProps {
  children: React.ReactNode;
  label?: string;
}
export const FilterGroup = ({ children, label }: FilterGroupProps) => (
  <FilterGroupContainer>
    {label && <FilterGroupHeader>{label}</FilterGroupHeader>}
    {children}
  </FilterGroupContainer>
);
